"use client"

import { useState } from "react"
import Link from "next/link"
import { ArrowRight } from "lucide-react"
import { Card, CardContent } from "@/components/ui/card"

export function TypeBrowser({ typeList, typeColors, questionsByType }) {
  const [activeType, setActiveType] = useState("Ethics")

  const questions = questionsByType[activeType] || []

  return (
    <div className="mt-6 flex flex-col gap-6 lg:flex-row lg:gap-8">
      {/* Sidebar - type selector */}
      <div className="lg:w-64 shrink-0">
        <div className="lg:sticky lg:top-20">
          <Card className="py-0 overflow-hidden">
            <CardContent className="p-0">
              <div className="divide-y">
                {typeList.map(({ type, slug, desc }) => (
                  <button
                    key={type}
                    onClick={() => setActiveType(type)}
                    className={`flex w-full items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-accent/50 ${activeType === type ? "bg-accent/30" : ""}`}
                  >
                    <span className={`mt-0.5 inline-flex shrink-0 items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold ${typeColors[type]}`}>
                      {type.slice(0, 3).toUpperCase()}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-semibold text-foreground">{type}</p>
                      <p className="text-[11px] text-muted-foreground leading-snug">{desc}</p>
                    </div>
                  </button>
                ))}
              </div>
            </CardContent>
          </Card>
          <p className="mt-3 text-center text-xs text-muted-foreground">
            Need frameworks? <Link href="/mmi-prep#question-types" className="text-primary underline underline-offset-4 hover:text-primary/80">Read the prep guide</Link>
          </p>
        </div>
      </div>

      {/* Main - example questions */}
      <div className="flex-1 space-y-4">
        <p className="text-sm font-medium text-foreground">
          Example {activeType.toLowerCase()} questions
        </p>
        <div className="space-y-2">
          {questions.map((q) => (
            <Link
              key={q.id}
              href={`/app?q=${q.id}`}
              className="group flex flex-col gap-3 rounded-lg border p-4 transition-colors hover:bg-accent/50"
            >
              <div className="flex items-start gap-3">
                <span className={`mt-0.5 inline-flex shrink-0 items-center rounded-md px-2 py-0.5 text-[11px] font-medium ${typeColors[activeType]}`}>
                  {activeType}
                </span>
                <p className="flex-1 text-sm leading-relaxed text-foreground">{q.q}</p>
              </div>
              <span className="inline-flex items-center gap-1 text-[11px] font-medium text-primary opacity-0 transition-opacity group-hover:opacity-100">
                Practice with AI interviewer <ArrowRight className="size-3" />
              </span>
            </Link>
          ))}
        </div>
        <Link
          href="/app"
          className="group flex items-center justify-center gap-2 rounded-lg border border-dashed p-4 text-sm font-medium text-muted-foreground transition-colors hover:border-primary/30 hover:text-foreground"
        >
          Practice more {activeType.toLowerCase()} questions in the app
          <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </div>
  )
}
